import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { CIVIL_CHECKLIST,FIRST_INTERACTION_FORM,CONFIGURATION_TESTING,VALET_GO_LIVE,DASHBOARD_TRAINING,DASHBOARD_TRAINING_CHK_DETAILS } from './type';

export const getCivilCheckList = (siteId,gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.civilCheckList}?siteId=${siteId}&gateId=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CIVIL_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const firstInteractionChecklist = (siteId,gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.firstInteractionChecklist}?siteId=${siteId}&gateId=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: FIRST_INTERACTION_FORM,
      payload: data.response.data,
    });
    return true;
  }
};

export const configurationAndTestingChecklist = (siteId,gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.configurationAndTestingChecklist}?siteId=${siteId}&gateId=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: CONFIGURATION_TESTING,
      payload: data.response.data,
    });
    return true;
  }
};

export const valetGoLiveChecklist = (siteId,gateId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.valetGoLiveChecklist}?siteId=${siteId}&gateId=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: VALET_GO_LIVE,
      payload: data.response.data,
    });
    return true;
  }
};

export const postCivilCheckList = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveCivilCheckList}`
  );
  if (res) {
    return true;
  }
};

export const postFirstInteractionCheckList = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveFirstInteractionCheckList}`
  );
  if (res) {
    return true;
  }
};

export const postConfigurationAndTesting = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveConfigurationAndTesting}`
  );
  if (res) {
    return true;
  }
};

export const postValetGoLive = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.postValetGoLive}`
  );
  if (res) {
    return true;
  }
};

export const postDashboardTrainingData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveDashboardTraining}`
  );
  if (res) {
    return true;
  }
};

export const getDashboardTrainingDetails = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getDashboardTrainingDetails}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: DASHBOARD_TRAINING,
      payload: data.response.data,
    });
    return true;
  }
};

export const postTrainingChecklistData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveDashboardTrainingChecklist}`
  );
  if (res) {
    return true;
  }
};

export const getDashboardTrainingChecklist = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getDashboardTrainingChecklist}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: DASHBOARD_TRAINING_CHK_DETAILS,
      payload: data.response.data,
    });
    return true;
  }
};